import Vue from "vue";
import Vuex from "vuex";
import { Setitem, Getitem } from "../utils/item.js";
import { saveAs } from "file-saver";
import { commonDataStructure, dataMappingRules } from "../utils/dataMapping.js";
import { triggerAutoCalculation } from "../utils/calculationScheduler.js";

Vue.use(Vuex);

// 辅助函数：获取嵌套对象的值
function getNestedValue(obj, path) {
  if (!obj) return undefined;

  const parts = path.split(".");
  let current = obj;

  for (const part of parts) {
    if (current === undefined || current === null) {
      return undefined;
    }
    current = current[part];
  }

  return current;
}

// 辅助函数：设置嵌套对象的值
function setNestedValue(obj, path, value) {
  const parts = path.split(".");
  let current = obj;

  for (let i = 0; i < parts.length - 1; i++) {
    if (!current[parts[i]]) {
      current[parts[i]] = {};
    }
    current = current[parts[i]];
  }

  current[parts[parts.length - 1]] = value;
  return obj;
}

export default new Vuex.Store({
  state: {
    mews: null,
    online: false,
    otherline: "离线",
    Swindow: "",
    newchat: {},
    manage: null,

    Slogin: false,
    Stemp: false,
    Islogin: null,
    menu: [],
    username: Getitem("name"),
    log401: "",
    tokenName: "",
    gochat: null,
    toid: "",
    porjecttype: {},
    ll: "",
    isonline: "",
    clist: false,
    msgs: {},
    prjectmenu: [],
    projectData: null,
    isProjectSaved: false,
    saveFileHandle: null,

    routerArr: {},
    newWork: "",

    userid: "",

    name: "",

    danganmingxi: {},

    xiangmumx: {},

    cash: [],

    msg: 0,

    number: 0,

    planamount: 0,

    depreciationData: [],
    amortizationData: [],

    // 公共数据，存储所有重复数据，特别是正常年指标
    commonData: { ...commonDataStructure },
  },

  getters: {
    getTotalInvestmentAmount: (state) => {
      if (state.projectData && state.projectData["总投资估算"]) {
        return state.projectData["总投资估算"].total || 0;
      }
      return 0;
    },
    getInvestmentPlanAmount: (state) => {
      if (state.projectData && state.projectData["资金筹措及分年投资计划"]) {
        const investmentPlan = state.projectData["资金筹措及分年投资计划"];
        if (investmentPlan.totalAmount !== undefined) {
          return investmentPlan.totalAmount;
        }
        if (
          investmentPlan["资金筹措"] &&
          investmentPlan["资金筹措"].length > 0
        ) {
          return investmentPlan["资金筹措"].reduce((sum, item) => {
            if (item.amount && !item.isGroup) {
              return sum + (item.amount || 0);
            }
            return sum;
          }, 0);
        }
      }
      return 0;
    },
    // 从公共数据获取项目基本信息
    getProjectInfo: (state) => {
      return state.commonData.projectInfo;
    },
    // 从公共数据获取投资信息
    getInvestmentInfo: (state) => {
      return state.commonData.investment;
    },
    // 从公共数据获取资金筹措信息
    getFinancingInfo: (state) => {
      return state.commonData.financing;
    },
    // 从公共数据获取正常年指标
    getNormalYearIndicators: (state) => {
      return state.commonData.normalYearIndicators;
    },
    // 获取正常年
    getNormalYear: (state) => {
      return state.commonData.projectInfo.normalYear || 0;
    },
  },

  mutations: {
    setmews(state, e) {
      state.mews = e;
    },
    setonline(state, e) {
      state.online = e;
    },

    setplanamount(state, e) {
      state.planamount = e;
    },
    setotherline(state, e) {
      state.otherline = e;
    },
    setSwindow(state, e) {
      state.Swindow = e;
    },
    setnewchat(state, e) {
      state.newchat = e;
    },
    setmanage(state, e) {
      state.manage = e;
    },

    SET_PROJECT_DATA(state, newData) {
      state.projectData = newData;
    },

    setmenu(state, e) {
      state.menu = e;
    },
    setIslogin(state, e) {
      state.Islogin = e;
    },
    setusername(state, e) {
      state.username = e;
    },
    setlog401(state, e) {
      state.log401 = e;
    },

    setTokenName(state, e) {
      state.tokenName = e;
    },
    setgochat(state, e) {
      state.gochat = e;
    },
    settoid(state, e) {
      state.toid = e;
    },

    setporjecttype(state, e) {
      state.porjecttype = e;
    },
    setll(state, e) {
      state.ll = e;
    },
    setisonline(state, e) {
      state.isonline = e;
    },

    setclist(state, e) {
      state.clist = e;
    },
    setmsgs(state, e) {
      state.msgs = e;
    },
    SETprjectmenu(state, e) {
      state.prjectmenu = e;
    },
    setSlogin(state, e) {
      state.Slogin = e;
    },
    setStemp(state, e) {
      state.Stemp = e;
    },

    setrouterArr(state, e) {
      state.routerArr = e;
    },
    login(state, e) {
      state.name = e;
    },

    newobj(state, s) {
      state.newWork = s;
    },

    runName(state, e) {
      state.name = e;
    },

    cuser(state, e) {
      state.username = e;
    },

    cusid(state, e) {
      state.userid = e;
    },

    dangan(state, e) {
      state.danganmingxi = e;
    },

    xmmx(state, e) {
      state.xiangmumx = e;
    },

    balance(state, e) {
      state.cash = e;
    },

    Dmegs(state, e) {
      state.msg = e;
    },

    setnumber(state, e) {
      state.number = e;
    },
    setProjectData(state, newData) {
      // 深拷贝数据以避免修改原始数据，使用自定义方法处理循环引用
      function deepCopy(obj, seen = new Set()) {
        if (obj === null || typeof obj !== 'object') {
          return obj;
        }
        if (seen.has(obj)) {
          return {}; // 处理循环引用，返回空对象
        }
        seen.add(obj);
        
        let copy;
        if (Array.isArray(obj)) {
          copy = [];
          for (let i = 0; i < obj.length; i++) {
            copy[i] = deepCopy(obj[i], seen);
          }
        } else {
          copy = {};
          for (let key in obj) {
            if (obj.hasOwnProperty(key)) {
              copy[key] = deepCopy(obj[key], seen);
            }
          }
        }
        
        seen.delete(obj);
        return copy;
      }
      
      let processedData = deepCopy(newData || {});

      // 检查并设置总投资到资金筹措计划
      if (processedData && processedData["总投资估算"]) {
        let totalInvestment = 0;

        // 优先从新的"总表"结构获取总投资
        if (
          processedData["总投资估算"]["总表"] &&
          processedData["总投资估算"]["总表"]["总投资"]
        ) {
          totalInvestment =
            processedData["总投资估算"]["总表"]["总投资"]["合计"] || 0;
        }
        // 兼容旧的直接total字段
        else if (typeof processedData["总投资估算"].total === "number") {
          totalInvestment = processedData["总投资估算"].total;
        }

        if (totalInvestment > 0) {
          if (!processedData["资金筹措及分年投资计划"]) {
            processedData["资金筹措及分年投资计划"] = {};
          }
          // 只添加或更新totalAmount，保留processedData中已有的资金筹措数据
          processedData["资金筹措及分年投资计划"].totalAmount = totalInvestment;
        }
      }

      // 直接执行syncProjectDataToCommon的逻辑
      if (processedData) {
        const newCommonData = { ...state.commonData };

        // 执行映射
        for (const [commonPath, projectPaths] of Object.entries(
          dataMappingRules.toCommonData
        )) {
          for (const projectPath of projectPaths) {
            const value = getNestedValue(processedData, projectPath);
            if (value !== undefined) {
              setNestedValue(newCommonData, commonPath, value);
              break;
            }
          }
        }

        state.commonData = newCommonData;
      }

      state.projectData = processedData;
      state.isProjectSaved = false;

      // 触发自动计算
      triggerAutoCalculation();
    },
    clearProjectData(state) {
      state.projectData = null;
      state.isProjectSaved = false;
    },
    setIsProjectSaved(state, e) {
      state.isProjectSaved = e;
    },
    setSaveFileHandle(state, e) {
      state.saveFileHandle = e;
    },
    setDepreciationData(state, e) {
      state.depreciationData = e;
    },
    setAmortizationData(state, e) {
      state.amortizationData = e;
    },
    // 更新公共数据
    updateCommonData(state, payload) {
      state.commonData = {
        ...state.commonData,
        ...payload,
      };
      state.isProjectSaved = false;
      // 自动同步到projectData
      if (state.projectData) {
        const newProjectData = { ...state.projectData };

        // 执行映射
        for (const [projectPath, commonPath] of Object.entries(
          dataMappingRules.fromCommonData
        )) {
          const value = getNestedValue(state.commonData, commonPath);
          if (value !== undefined) {
            setNestedValue(newProjectData, projectPath, value);
          }
        }

        state.projectData = newProjectData;
      }
      // 触发自动计算
      triggerAutoCalculation();
    },
    // 更新公共数据中的特定属性
    updateCommonDataProperty(state, { path, value }) {
      const pathParts = path.split(".");
      let current = state.commonData;

      // 遍历路径，找到最后一级对象
      for (let i = 0; i < pathParts.length - 1; i++) {
        if (!current[pathParts[i]]) {
          current[pathParts[i]] = {};
        }
        current = current[pathParts[i]];
      }

      // 更新值
      current[pathParts[pathParts.length - 1]] = value;
      state.isProjectSaved = false;
      // 自动同步到projectData
      if (state.projectData) {
        const newProjectData = { ...state.projectData };

        // 执行映射
        for (const [projectPath, commonPath] of Object.entries(
          dataMappingRules.fromCommonData
        )) {
          const val = getNestedValue(state.commonData, commonPath);
          if (val !== undefined) {
            setNestedValue(newProjectData, projectPath, val);
          }
        }

        state.projectData = newProjectData;
      }
      // 触发自动计算
      triggerAutoCalculation();
    },
    // 从projectData同步到公共数据
    syncProjectDataToCommon(state) {
      if (!state.projectData) return;

      const newCommonData = { ...state.commonData };

      // 执行映射
      for (const [commonPath, projectPaths] of Object.entries(
        dataMappingRules.toCommonData
      )) {
        for (const projectPath of projectPaths) {
          const value = getNestedValue(state.projectData, projectPath);
          if (value !== undefined) {
            setNestedValue(newCommonData, commonPath, value);
            break;
          }
        }
      }

      state.commonData = newCommonData;
      // 触发自动计算
      triggerAutoCalculation();
    },
    // 将公共数据同步到projectData
    syncCommonDataToProject(state) {
      if (!state.projectData) return;

      const newProjectData = { ...state.projectData };

      // 执行映射
      for (const [projectPath, commonPath] of Object.entries(
        dataMappingRules.fromCommonData
      )) {
        const value = getNestedValue(state.commonData, commonPath);
        if (value !== undefined) {
          setNestedValue(newProjectData, projectPath, value);
        }
      }

      state.projectData = newProjectData;
      state.isProjectSaved = false;
      // 触发自动计算
      triggerAutoCalculation();
    },
    // 清空公共数据
    clearCommonData(state) {
      state.commonData = { ...commonDataStructure };
    },
    updateInvestmentEstimate(state, data) {
      if (!state.projectData) {
        state.projectData = {};
      }
      if (!state.projectData.investmentEstimate) {
        state.projectData.investmentEstimate = {};
      }
      if (!state.projectData.investmentEstimate.rawMaterialsData) {
        state.projectData.investmentEstimate.rawMaterialsData = {
          tableData: [],
          totalAmount: 0,
        };
      }

      const rawMaterialsData =
        state.projectData.investmentEstimate.rawMaterialsData;

      if (data.rawMaterials !== undefined) {
        rawMaterialsData.rawMaterials = data.rawMaterials;
      }
      if (data.unitPrices !== undefined) {
        rawMaterialsData.unitPrices = data.unitPrices;
      }
      if (data.quantities !== undefined) {
        rawMaterialsData.quantities = data.quantities;
      }
      if (data.taxRates !== undefined) {
        rawMaterialsData.taxRates = data.taxRates;
      }
      if (data.auxiliaryCosts !== undefined) {
        rawMaterialsData.auxiliaryCosts = data.auxiliaryCosts;
      }
      if (data.auxiliaryTaxRates !== undefined) {
        rawMaterialsData.auxiliaryTaxRates = data.auxiliaryTaxRates;
      }
      if (data.otherCosts !== undefined) {
        rawMaterialsData.otherCosts = data.otherCosts;
      }
      if (data.otherTaxRates !== undefined) {
        rawMaterialsData.otherTaxRates = data.otherTaxRates;
      }
    },
  },

  actions: {
    weijiedan(st, e) {
      st.commit("newobj", e);
    },

    runname(state, e) {
      state.commit("runName", e);
    },

    cusername(state, e) {
      state.commit("cuser", e);
    },

    cuserid(state, e) {
      state.commit("cusid", e);
    },

    bianhuan(state, e) {
      state.commit("dangan", e);
    },

    xmMx(state, e) {
      state.commit("xmmx", e);
    },

    Cash(state, e) {
      state.commit("balance", e);
    },

    Dmsg(state, e) {
      state.commit("Dmegs", e);
    },
    saveProjectToJson({ commit, rootState }) {
      console.log("=== 开始保存项目到JSON ===");
      console.log("当前时间:", new Date().toISOString());
      console.log("saveFileHandle存在:", !!rootState.saveFileHandle);
      console.log(
        "saveFileHandle类型:",
        rootState.saveFileHandle ? typeof rootState.saveFileHandle : "null"
      );
      if (rootState.saveFileHandle) {
        console.log(
          "saveFileHandle内容:",
          JSON.stringify(rootState.saveFileHandle, null, 2)
        );
        console.log(
          "是否为传统文件:",
          rootState.saveFileHandle.isTraditionalFile
        );
        console.log(
          "是否有createWritable方法:",
          typeof rootState.saveFileHandle.createWritable === "function"
        );
      }
      console.log("项目数据存在:", !!rootState.projectData);
      if (rootState.projectData) {
        console.log("项目数据类型:", typeof rootState.projectData);
        console.log(
          "项目数据大小:",
          JSON.stringify(rootState.projectData).length
        );
        console.log("项目名称:", rootState.projectData.projectName);
        console.log(
          "项目数据结构:",
          JSON.stringify(Object.keys(rootState.projectData), null, 2)
        );
      }

      const projectData = rootState.projectData;
      if (!projectData) {
        console.error("项目数据为空，无法保存");
        return Promise.reject("项目数据为空");
      }

      let jsonString;
      try {
        jsonString = JSON.stringify(projectData, null, 2);
        console.log("JSON序列化成功，长度:", jsonString.length);
        console.log("JSON内容前500字符:", jsonString.substring(0, 500));
      } catch (error) {
        console.error("JSON序列化失败:", error);
        console.error("错误类型:", error.name);
        console.error("错误消息:", error.message);
        return Promise.reject("JSON序列化错误");
      }

      let fileName;
      if (projectData.projectName && projectData.projectName.trim()) {
        fileName = `${projectData.projectName}.json`;
        console.log("使用项目名称作为文件名:", fileName);
      } else if (
        rootState.saveFileHandle &&
        rootState.saveFileHandle.isTraditionalFile
      ) {
        fileName = rootState.saveFileHandle.filename;
        console.log("使用传统文件选择的文件名:", fileName);
      } else {
        fileName = `项目_${new Date().getTime()}.json`;
        console.log("使用时间戳作为文件名:", fileName);
      }

      if (
        rootState.saveFileHandle &&
        typeof rootState.saveFileHandle.createWritable === "function"
      ) {
        console.log("使用File System Access API保存文件");
        return rootState.saveFileHandle
          .createWritable()
          .then((writable) => {
            console.log("成功创建可写流");
            return writable.write(jsonString).then(() => {
              console.log("成功写入数据");
              return writable.close();
            });
          })
          .then(() => {
            commit("setIsProjectSaved", true);
            console.log("=== 保存完成：使用File System Access API ===");
            return Promise.resolve("项目已成功保存到原文件");
          })
          .catch((err) => {
            console.error("使用File System Access API保存失败：", err);
            console.error("错误类型:", err.name);
            console.error("错误消息:", err.message);
            console.error("=== 保存失败：使用File System Access API ===");
            return Promise.reject("保存失败：" + err.message);
          });
      } else {
        console.log("使用传统下载方式保存文件");
        console.log(
          "是否支持File System Access API:",
          "showOpenFilePicker" in window
        );
        console.log("是否有saveAs函数:", typeof saveAs === "function");
        console.log("文件名:", fileName);
        console.log("JSON字符串长度:", jsonString.length);

        const blob = new Blob([jsonString], {
          type: "application/json;charset=utf-8",
        });
        console.log("创建的Blob对象:", blob);
        console.log("Blob大小:", blob.size);
        console.log("Blob类型:", blob.type);

        if (typeof saveAs === "function") {
          try {
            console.log("使用file-saver库保存文件");
            saveAs(blob, fileName);
            console.log("file-saver保存成功");

            commit("setIsProjectSaved", true);
            console.log("=== 保存完成：使用file-saver ===");
            return Promise.resolve("项目已成功保存到本地文件");
          } catch (error) {
            console.error("file-saver保存失败:", error);
            console.error("错误类型:", error.name);
            console.error("错误消息:", error.message);
            console.error("错误堆栈:", error.stack);
          }
        } else {
          console.warn("file-saver库不可用，将使用原生下载方式");
        }

        try {
          console.log("使用原生下载方式保存文件");

          const url = URL.createObjectURL(blob);
          console.log("创建的下载URL:", url);

          const link = document.createElement("a");
          link.href = url;
          link.download = fileName;
          link.style.display = "none";
          link.rel = "noopener noreferrer";
          console.log("创建的a标签:", link);

          document.body.appendChild(link);
          console.log("a标签已添加到DOM");

          link.click();
          console.log("a标签点击事件已触发");

          setTimeout(() => {
            console.log("清理下载资源");
            document.body.removeChild(link);
            URL.revokeObjectURL(url);
          }, 100);

          commit("setIsProjectSaved", true);
          console.log("=== 保存完成：使用原生下载方式 ===");
          return Promise.resolve("项目已成功保存到本地文件");
        } catch (nativeError) {
          console.error("原生下载方式也失败了:", nativeError);
          console.error("错误类型:", nativeError.name);
          console.error("错误消息:", nativeError.message);
          console.error("错误堆栈:", nativeError.stack);
          return Promise.reject("保存失败：" + nativeError.message);
        }
      }
    },
  },

  modules: {},
});
